/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ReactPropTypes from 'prop-types';
import { inject, observer, PropTypes } from 'mobx-react';
import AnalyticComponent from 'Components/VideoAnalytic';
class Analytic extends Component {
  static propTypes = {
    VideoAnalyticStore: PropTypes.observableObject,
    match: ReactPropTypes.object
  };

  componentWillMount() {
    this.setReportType();
    this.selectItem();
    this.props.VideoAnalyticStore.reload();
  }

  componentDidUpdate(nextProps) {
    this.setReportType();
    this.selectItem();
  }

  setReportType = () => {
    this.props.VideoAnalyticStore.setReportType(
      document.location.pathname.split('/')[2]
    );
  };

  selectItem = () => {
    const { VideoAnalyticStore } = this.props;
    const { itemId = null } = this.props.match.params || {};
    VideoAnalyticStore.selectItem(itemId);
  };

  render() {
    const {
      isLoadingVideos,
      isLoadingCustomers,
      isLoadingGeneral,
      reportType,
      videos,
      customers,
      general,
      selectedItem,
      changeInterval,
      interval,
      startDate,
      endDate,
      setDateRange,
      searchTerm,
      setSearch
    } = this.props.VideoAnalyticStore;

    return (
      <AnalyticComponent
        reportType={reportType}
        selectedItem={selectedItem}
        videos={{ isLoading: isLoadingVideos, videos }}
        customers={{ isLoading: isLoadingCustomers, customers }}
        general={{ isLoading: isLoadingGeneral, ...general }}
        selectDateInterval={changeInterval}
        selectedInterval={interval}
        startDate={startDate}
        endDate={endDate}
        setDateRange={setDateRange}
        searchTerm={searchTerm}
        setSearch={setSearch}
      />
    );
  }
}

export default inject('VideoAnalyticStore')(withRouter(observer(Analytic)));
